import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import ChainedBackend from "i18next-chained-backend";
import I18NextLocalStorageBackend from "i18next-localstorage-backend";
import { requestJira } from "@forge/bridge";

i18n
  .use(ChainedBackend)
  .use({
    type: "languageDetector",
    async: true,
    detect(callback) {
      requestJira("/rest/api/3/mypreferences/locale")
        .then((res) => res.json())
        .then((data) => {
          const { locale = "en-US" } = data || {};
          const localeCode = locale?.split("_")?.[0];
          callback(localeCode);
        })
        .catch(() => callback("en"));
    },
  })
  .use(initReactI18next)
  .init({
    debug: false,
    load: "languageOnly",
    fallbackLng: "en",
    backend: {
      backends: [I18NextLocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          expirationTime: 10 * 1000,
        },
        {
          loadPath: `locales/{{lng}}.json`,
        },
      ],
    },
  });
export default i18n;
